import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  user_id : any
  check_id:any
  URLlink:any
  constructor( public router : Router){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      this.user_id = localStorage.getItem("user_id_lsm")
      console.log(this.user_id)
       if(this.user_id == null || this.user_id == 'null' || this.user_id == 'undefined' || this.user_id == undefined  || this.user_id== ''){
          this.router.navigate(['login-type'])
          return false; 
    }
    else{
      return true;
    }
  }

}
